import AppConstants from '../constants/appConstants';
import { authGet } from '../utils/fecth-wrappers';
import { parseLaunchWindowsResponse } from '../utils/launchWindows';

/**
 * GET /admin/auction-config/launch-windows
 * Retorna a grade de janelas (7 dias) usada pelo banner de subidas de lotes.
 */
export async function fetchLaunchWindowsConfig() {
  const response = await authGet(AppConstants.API.launchWindows);

  if (response?.responseStatus) {
    throw new Error('Não foi possível carregar as janelas de subida de lotes');
  }

  return parseLaunchWindowsResponse(response);
}
